import React from 'react';
import { ListVideoIcon, ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { channel } from '../data/channel';
import { playlistUrl, totalMinutes, videoThumbnail } from '../utils/video';
import type { Playlist, Video } from '../types/video';
interface PlaylistsProps {
  playlists: Playlist[];
  videos: Video[];
}
export function Playlists({
  playlists,
  videos
}: PlaylistsProps) {
  return <section id="playlists" aria-labelledby="playlists-title" className="scroll-mt-20 border-t border-line py-20 md:py-28" data-id="element-59" data-mp="1ko92sjlk685e">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-60" data-mp="1pk6jir0qhgip">
        <SectionHeading id="playlists-title" title="Серії, які дивляться запоєм" subtitle="Обирайте настрій — і вмикайте всю добірку від першого до останнього кілометра." link={{
        href: `${channel.url}/playlists`,
        label: 'Усі плейлисти'
      }} data-id="element-61" data-mp="1blzv01hocsvp" />

        <ul className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-62" data-mp="4a941byg8ojq">
          {playlists.map(playlist => {
          const items = videos.filter(v => v.playlists?.includes(playlist.id));
          const cover = [...items].sort((a, b) => b.views - a.views)[0];
          return <li key={playlist.id} data-id="element-63" data-mp="23xmoa62xk26w">
                <a href={playlistUrl(playlist)} target="_blank" rel="noopener noreferrer" className="group grid h-full grid-cols-[minmax(0,2fr)_minmax(0,3fr)] overflow-hidden rounded-2xl bg-surface transition-colors duration-150 hover:bg-raised focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember" data-id="element-64" data-mp="23yo6qvm9zqyn">
                  <div className="relative min-h-[180px] overflow-hidden" data-id="element-65" data-mp="2im9betysty8o">
                    {cover && <img src={videoThumbnail(cover)} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-66" data-mp="2wl8zo0iegb4b" />}
                    <span className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 rounded-md bg-ink/85 px-2 py-1 text-xs font-bold text-paper" data-id="element-67" data-mp="1u8vxpgnjyp92">
                      <ListVideoIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="2317qh9652os7" />
                      {items.length} відео
                    </span>
                  </div>
                  <div className="flex flex-col p-5 md:p-6" data-id="element-69" data-mp="282589kn8lgt6">
                    <h3 className="font-display text-lg font-semibold text-paper md:text-xl" data-id="element-70" data-mp="2cxaoq3xve39v">{playlist.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-71" data-mp="2hyq8lsoba3qo">{playlist.description}</p>
                    <div className="mt-auto flex items-center justify-between pt-5" data-id="element-72" data-mp="2lyqyc9gv21d1">
                      <span className="text-sm text-muted" data-id="element-73" data-mp="nliclxolnm3g">≈ {totalMinutes(items)} хв перегляду</span>
                      <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-ember" data-id="element-74" data-mp="rm139oeram42">
                        Дивитись
                        <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-75" data-mp="farrlw2pjif9" />
                      </span>
                    </div>
                  </div>
                </a>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}